import { Button, ButtonGroup, FormFeedback } from 'reactstrap';
import styled from 'styled-components';
import GroupedTypeahead from '../../GroupedTypeahead';

export const ListItemContainer = styled.div`
  &:not(:last-child) {
    input,
    button {
      ${({ $hasError }) =>
        $hasError
          ? `
        border: none;
        border-bottom: 1px solid var(--text-muted-color)
        `
          : 'border-bottom: none !important;'}
    }
    input {
      border-bottom-left-radius: 0;
    }
    button {
      border-bottom-right-radius: 0;
    }
  }
  &:not(:first-child) {
    input {
      border-top-left-radius: 0;
    }
    button {
      border-top-right-radius: 0;
    }
  }

  button,
  button:hover {
    border-left: 1px solid var(--text-muted-color) !important;
  }

  ${({ $hasError }) => $hasError && 'border: 1px solid #dc3545;'}
`;

const StyledSquareButton = styled(Button)`
  padding: 6px 10px;
  font-size: 0.875rem;
  text-align: center;
  align-items: center;
  min-width: 36px;
  min-height: 36px;
`;

const SquareXButton = ({ onClick }) => (
  <StyledSquareButton outline onClick={onClick}>
    ✕
  </StyledSquareButton>
);

export const SquarePlusButton = ({ onClick }) => (
  <div>
    <StyledSquareButton outline onClick={onClick}>
      ＋
    </StyledSquareButton>
  </div>
);

const SelectorFormGroupTypeahead = styled(GroupedTypeahead)`
  input {
    font-size: 0.875rem;
    box-sizing: content-box;
    padding: 0 8px;
  }
`;

export const SelectorFormGroup = ({
  removeOption,
  shouldShowError,
  error,
  ...props
}) => (
  <ListItemContainer $hasError={shouldShowError}>
    <ButtonGroup>
      <SelectorFormGroupTypeahead align="left" positionFixed {...props} />
      <SquareXButton onClick={removeOption} />
    </ButtonGroup>
    {shouldShowError && (
      <FormFeedback className="d-block p-1">{error}</FormFeedback>
    )}
  </ListItemContainer>
);
